export default "__VITE_ASSET__DNDsETny__"